<template>
  <div class="more-action">
    <el-dropdown
      ref="dropdownRef"
      position="bottom-end"
      :show-arrow="false"
      size="large"
      @command="handleDropdownCommand"
    >
      <span class="el-dropdown-link">
        <el-icon class="el-icon--right">
          <MoreFilled />
        </el-icon>
      </span>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item command="intro">查看功能说明</el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<script setup lang="ts">
import { _, computed, ref, useHostAppInstance } from '@zto/zpage'
import { ElementPlusIcons } from '@zto/zpage-ui-element'
import { GLOBAL_EVENTS } from '../../../../consts'

const { MoreFilled } = ElementPlusIcons

const props = defineProps<{
  menu?: any
}>()

const app = useHostAppInstance()

const dropdownRef = ref<any>()

function handleDropdownCommand(command: string) {
  switch (command) {
    case 'intro':
      handleIntro()
      break
  }
}

async function handleIntro() {
  const menuCopy = _.deepClone(props.menu)

  app.emitter.emit(GLOBAL_EVENTS.OPEN_MENU_INTRO, {
    menu: menuCopy
  })
}
</script>

<style lang="scss" scoped>
.more-action {
  display: inline-block;
}
</style>
